import React from 'react';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from './AdminDashboard';
import '../styles/Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

function EmpresaCard() {
  const { empresa, user } = useAuth();

  const logoSrc   = empresa?.logo ? `${API_URL}${empresa.logo}` : null;
  const nombre    = empresa?.razon_social || user?.business_name || 'Sistema de Gestión';
  const ruc       = empresa?.ruc;
  const direccion = empresa?.direccion;
  const telefono  = empresa?.telefono;
  const correo    = empresa?.correo;

  return (
    <div className="dashboard">
      <div className="dash-empresa-card">
        {logoSrc && (
          <img
            src={logoSrc}
            alt={nombre}
            className="dash-empresa-logo"
            onError={e => { e.currentTarget.style.display = 'none'; }}
          />
        )}
        <div className="dash-empresa-info">
          <h1 className="dash-empresa-nombre">{nombre}</h1>
          {ruc       && <p className="dash-empresa-dato">RUC: {ruc}</p>}
          {direccion && <p className="dash-empresa-dato">{direccion}</p>}
          <div className="dash-empresa-contacto">
            {telefono && <span>{telefono}</span>}
            {correo   && <span>{correo}</span>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const { user } = useAuth();
  const isAdmin  = user?.perfil_es_admin || user?.rol === 'admin';

  if (isAdmin) return <AdminDashboard />;
  return <EmpresaCard />;
}
